import React from 'react';

export default function ContactPage() {
  return (
    <div style={S.page}>
      {/* Header */}
      <div style={S.header}>
        <div style={S.badge}>📬 Get In Touch</div>
        <h1 style={S.title}>Contact <span style={S.accent}>UNI GLOBAL</span></h1>
        <p style={S.subtitle}>We're here to help you with your referral journey</p>
      </div>

      {/* Main contact cards */}
      <div style={S.cardsRow} className="contact-cards">
        <div style={{ ...S.card, ...S.cardPhone }}>
          <div style={S.cardGlow} />
          <div style={S.cardIconWrap}>
            <span style={S.cardIcon}>📞</span>
          </div>
          <div style={S.cardLabel}>Main Phone</div>
          <a href="tel:+919177454500" style={{ ...S.cardValue, color: '#60a5fa' }}>+91 9177454500</a>
          <div style={S.cardHint}>Tap to call</div>
        </div>

        <div style={{ ...S.card, ...S.cardEmail }}>
          <div style={{ ...S.cardGlow, background: 'radial-gradient(circle at top, rgba(167,139,250,0.35) 0%, transparent 70%)' }} />
          <div style={{ ...S.cardIconWrap, background: 'rgba(167,139,250,0.15)', border: '1.5px solid rgba(167,139,250,0.4)' }}>
            <span style={S.cardIcon}>✉️</span>
          </div>
          <div style={S.cardLabel}>Email Us</div>
          <a href="mailto:info@uniglobaleducon.com" style={{ ...S.cardValue, color: '#a78bfa', fontSize: '.95rem' }}>info@uniglobaleducon.com</a>
          <div style={S.cardHint}>We reply within 24 hours</div>
        </div>

        <div style={{ ...S.card, ...S.cardWeb }}>
          <div style={{ ...S.cardGlow, background: 'radial-gradient(circle at top, rgba(52,211,153,0.3) 0%, transparent 70%)' }} />
          <div style={{ ...S.cardIconWrap, background: 'rgba(52,211,153,0.12)', border: '1.5px solid rgba(52,211,153,0.4)' }}>
            <span style={S.cardIcon}>🌐</span>
          </div>
          <div style={S.cardLabel}>Website</div>
          <a href="https://uniglobaleducon.com/" target="_blank" rel="noopener noreferrer" style={{ ...S.cardValue, color: '#34d399' }}>uniglobaleducon.com</a>
          <div style={S.cardHint}>Visit our official site</div>
        </div>
      </div>

      {/* Support numbers */}
      <div style={S.supportBox}>
        <div style={S.supportHeader}>
          <span style={S.supportIcon}>🎧</span>
          <div>
            <div style={S.supportTitle}>Referral Support</div>
            <div style={S.supportSub}>For referral program queries</div>
          </div>
        </div>
        <div style={S.numsRow}>
          {[
            { num: '7429992222', color: '#fbbf24' },
            { num: '7429993333', color: '#f472b6' },
            { num: '7429995555', color: '#34d399' },
          ].map(({ num, color }, i) => (
            <React.Fragment key={num}>
              <a href={`tel:${num}`} style={{ ...S.numChip, borderColor: color, color }}>
                <span style={{ fontSize: '.85rem' }}>📱</span> {num}
              </a>
              {i < 2 && <span style={S.sep}>|</span>}
            </React.Fragment>
          ))}
        </div>
      </div>

      {/* Bottom note */}
      <div style={S.note}>
        <span>🕐</span>
        <span>Available Monday – Saturday, 9:00 AM – 6:00 PM IST</span>
      </div>
    </div>
  );
}

const S = {
  page: {
    minHeight: 'calc(100vh - 64px)',
    background: 'linear-gradient(145deg, #0f172a 0%, #1e1b4b 50%, #0f172a 100%)',
    display: 'flex', flexDirection: 'column', alignItems: 'center',
    padding: '3rem 1.5rem 3rem',
    fontFamily: "'Inter', 'Segoe UI', sans-serif",
  },

  /* Header */
  header: { textAlign: 'center', maxWidth: 600, marginBottom: '2.5rem' },
  badge: {
    display: 'inline-flex', alignItems: 'center', gap: '.4rem',
    background: 'linear-gradient(90deg, rgba(96,165,250,0.2), rgba(167,139,250,0.2))',
    border: '1px solid rgba(96,165,250,0.4)', borderRadius: 20,
    padding: '.35rem 1.1rem', fontSize: '.82rem', fontWeight: 700,
    color: '#bfdbfe', letterSpacing: '.04em', marginBottom: '1rem',
    textTransform: 'uppercase',
  },
  title: { fontSize: '2.4rem', fontWeight: 900, color: '#fff', margin: '0 0 .6rem', lineHeight: 1.2 },
  accent: {
    background: 'linear-gradient(90deg, #60a5fa, #a78bfa)',
    WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
  },
  subtitle: { color: '#94a3b8', fontSize: '1rem', margin: 0 },

  /* Cards */
  cardsRow: {
    display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '1.25rem', width: '100%', maxWidth: 860, marginBottom: '1.5rem',
  },
  card: {
    position: 'relative', overflow: 'hidden',
    borderRadius: 16, padding: '2rem 1.5rem',
    display: 'flex', flexDirection: 'column', alignItems: 'center',
    textAlign: 'center', gap: '.35rem',
  },
  cardPhone: {
    background: 'rgba(96,165,250,0.07)',
    border: '1px solid rgba(96,165,250,0.3)',
  },
  cardEmail: {
    background: 'rgba(167,139,250,0.07)',
    border: '1px solid rgba(167,139,250,0.3)',
  },
  cardWeb: {
    background: 'rgba(52,211,153,0.07)',
    border: '1px solid rgba(52,211,153,0.3)',
  },
  cardGlow: {
    position: 'absolute', top: 0, left: 0, right: 0, height: 120,
    background: 'radial-gradient(circle at top, rgba(96,165,250,0.35) 0%, transparent 70%)',
    pointerEvents: 'none',
  },
  cardIconWrap: {
    width: 56, height: 56, borderRadius: '50%',
    background: 'rgba(96,165,250,0.12)', border: '1.5px solid rgba(96,165,250,0.4)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    marginBottom: '.5rem', position: 'relative',
  },
  cardIcon: { fontSize: '1.5rem' },
  cardLabel: { fontSize: '.72rem', color: '#94a3b8', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '.06em' },
  cardValue: { fontWeight: 800, fontSize: '1.05rem', textDecoration: 'none', position: 'relative' },
  cardHint: { fontSize: '.72rem', color: '#475569', marginTop: '.1rem' },

  /* Support box */
  supportBox: {
    width: '100%', maxWidth: 860,
    background: 'rgba(251,191,36,0.06)', border: '1px solid rgba(251,191,36,0.25)',
    borderRadius: 16, padding: '1.5rem 2rem', marginBottom: '1.25rem',
  },
  supportHeader: { display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1.25rem' },
  supportIcon: { fontSize: '2rem' },
  supportTitle: { fontSize: '1rem', fontWeight: 800, color: '#fde68a' },
  supportSub: { fontSize: '.78rem', color: '#92400e', marginTop: '.1rem', color: '#fbbf24' },
  numsRow: { display: 'flex', alignItems: 'center', gap: '.75rem', flexWrap: 'wrap' },
  numChip: {
    display: 'inline-flex', alignItems: 'center', gap: '.4rem',
    padding: '.5rem 1rem', borderRadius: 10, border: '1.5px solid',
    fontWeight: 800, fontSize: '.95rem', textDecoration: 'none',
    background: 'rgba(255,255,255,0.04)',
  },
  sep: { color: '#475569', fontWeight: 700 },

  /* Note */
  note: {
    display: 'flex', gap: '.6rem', alignItems: 'center',
    background: 'rgba(148,163,184,0.07)', border: '1px solid rgba(148,163,184,0.15)',
    borderRadius: 10, padding: '.65rem 1.1rem', fontSize: '.8rem',
    color: '#64748b', maxWidth: 860, width: '100%',
  },
};
